import React from 'react'
import {Link} from 'react-router-dom'
function Advance_program_card() {
  return (
    <>
    {/* -------------------------Mobile View---------------------- */}
    <div className='d-sm-block d-md-none'>
        <div className='container mt-3'>
            <div className='row '>
                <div className='col-md-12 Mobile_card my-3'>
                    <div>
                    <div className="Program_card">
                        <div className="card">
                        <div className="image">
                            <img href = "#" src ="https://img.freepik.com/free-vector/laptop-with-program-code-isometric-icon-software-development-programming-applications-dark-neon_39422-971.jpg?w=900&t=st=1696570141~exp=1696570741~hmac=66f06295c721fcc6895fe23d98e3792e41eeb12993c1d9c2e2c18125971fd36a"></img>
                            <h5 className='fw-bold text-center py-2 Program_name_text'>Java</h5>
                        </div>
                        <div className='content'>
                            <ul className='our_program_card_text pt-5 px-2'>
                                <p className='text-center'>Take a thorough tour of Core Java and learn about basic ideas like classes, objects, packages, data types, and methods. Explore more complex subjects such as inner classes, encapsulation, inheritance, polymorphism, static and final keywords, and abstraction. Learn </p>
                            </ul>
                            <div className='text-center'>
                            <Link to="/java"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                            </div>
                        </div>
                        </div>    
                    </div>
                    </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                    <div className="Program_card">
                        <div className="card">
                        <div className="image">
                            <img href = "#" src ="https://img.freepik.com/free-photo/ai-site-helping-with-software-production_1268-21620.jpg?w=1060&t=st=1696570203~exp=1696570803~hmac=de65920f2642f6e3e442bbb64b97508c07e1fc284b089f45fc15f220e70580c7"></img>
                            <h5 className='fw-bold text-center py-2 Program_name_text'>Python</h5>
                        </div>
                        <div className='content'>
                            <ul className='our_program_card_text pt-5 px-2'>
                                <p className='text-center'>Take a thorough look at Python and learn about data structures, advanced concepts, and programming basics. Investigate database operations, optimize code efficiency, and learn about Python libraries. Use pandas, statistical ideas, and hypothesis testing to navigate data </p>
                            </ul>
                            <div className='text-center'>
                            <Link to="/PY"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                            </div>
                        </div>
                        </div>    
                    </div>
                    </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                    <div className="Program_card">
                        <div className="card">
                        <div className="image">
                            <img href = "#" src ="https://img.freepik.com/free-photo/marketing-business-branding-advertising-word_53876-163235.jpg?w=996&t=st=1696570263~exp=1696570863~hmac=9038ed02b756eb7d41608651839e8873892ca936f40ec48bdedd12ab3b96a126"></img>
                            <h5 className='fw-bold text-center fs-6 py-2  Program_name_text mt-2'>Digital Marketing & Marketing</h5>
                        </div>
                        <div className='content'>
                            <ul className='our_program_card_text pt-5 px-2'>
                                <p className='text-center'>With the help of our extensive Digital Marketing course, take a fascinating voyage into the digital world. Examine the nuances of email and content marketing, from SEO and social media marketing to designing and creating advertisements. Explore strategies for Quora </p>
                            </ul>
                            <div className='text-center'>
                            <Link to="/DMM"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                            </div>
                        </div>
                        </div>    
                    </div>
                    </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                    <div>
                    <div className="Program_card">
                        <div className="card">
                        <div className="image">
                            <img href = "#" src ="https://img.freepik.com/free-photo/medium-shot-man-working-laptop_23-2150323506.jpg?w=900&t=st=1696570322~exp=1696570922~hmac=a9760245a94018338e060424af238e36c4ca2f5c50c29538c790b1ddcaba4efc"></img>
                            <h5 className='fw-bold text-center fs-6 py-2 Program_name_text mt-2'>Full Stack Web Development</h5>
                        </div>
                        <div className='content'>
                            <ul className='our_program_card_text pt-5 px-2'>
                                <p className='text-center'>Learn HTML, CSS, Bootstrap, SASS, JavaScript, DOM manipulation, jQuery, Node.js, SQL, React, WordPress, and Django as you embark on an extensive journey into Full Stack Web Development. This course covers the whole range, from basic concepts to sophisticated</p>
                            </ul>
                            <div className='text-center'>
                            <Link to="/FSW"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                            </div>
                        </div>
                        </div>    
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div className='container'>
            <div className='row'>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                    <div className="Program_card">
                        <div className="card">
                        <div className="image">
                            <img href = "#" src ="https://img.freepik.com/free-photo/technology-coffee-internet-beverage-cafe-data-concept_53876-23193.jpg?w=996&t=st=1696570412~exp=1696571012~hmac=ff1ab40b141c279c2fd5455b186284db5483cfee1012329e9758277737f131e0"></img>
                            <h5 className='fw-bold  text-center py-2 Program_name_text'>Mern Stack</h5>
                        </div>
                        <div className='content'>
                            <ul className='our_program_card_text pt-5 px-2'>
                                <p className='text-center'>Take a look at the exciting field of web development with our in-depth MERN stack course. Beginning with laying a solid foundation in HTML, CSS, and JavaScript, you can go on to learn React for effective front-end development, explore Node.js and Express.js for reliable </p>
                            </ul>
                            <div className='text-center'>
                            <Link to='/MS'><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                            </div>
                        </div>
                        </div>    
                    </div>
                </div>
                </div>
                <div className='col-md-12 Mobile_card my-3'>
                <div>
                    <div className="Program_card">
                        <div className="card">
                        <div className="image">
                            <img href = "#" src ="https://img.freepik.com/free-photo/turned-gray-laptop-computer_400718-47.jpg?w=996&t=st=1696570575~exp=1696571175~hmac=eabaaef31c141132c9949923562b941c76965b85b24926ffa92daf109d4fd9ed  "></img>
                            <h5 className='fw-bold text-center py-2 Program_name_text'>C, C++ with DSA </h5>
                        </div>
                        <div className='content'>
                            <ul className='our_program_card_text pt-5 px-2'>
                                <p className='text-center'>Take a thorough look at Data Structures & Algorithms and C/C++ programming. This course gives you the tools to take on challenges in the real world. You will learn about advanced topics like OOPs, Trees, and Dynamic Programming, as well as fundamental concepts like </p>
                            </ul>
                            <div className='text-center'>
                            <Link to="/CCD"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                            </div>
                        </div>
                        </div>    
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    {/* ----------------------Desktop View------------------------------- */}
    <div className='d-none d-md-block'>
      <div className='container'>
            <div className='row '>
                <div className='col-md-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-vector/laptop-with-program-code-isometric-icon-software-development-programming-applications-dark-neon_39422-971.jpg?w=900&t=st=1696570141~exp=1696570741~hmac=66f06295c721fcc6895fe23d98e3792e41eeb12993c1d9c2e2c18125971fd36a"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Java</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Take a thorough tour of Core Java and learn about basic ideas like classes, objects, packages, data types, and methods. Explore more complex subjects such as inner classes, encapsulation, inheritance, polymorphism, static and final keywords, and abstraction. Learn </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/java"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/ai-site-helping-with-software-production_1268-21620.jpg?w=1060&t=st=1696570203~exp=1696570803~hmac=de65920f2642f6e3e442bbb64b97508c07e1fc284b089f45fc15f220e70580c7"></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>Python</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                             <p className='text-center'>Take a thorough look at Python and learn about data structures, advanced concepts, and programming basics. Investigate database operations, optimize code efficiency, and learn about Python libraries. Use pandas, statistical ideas, and hypothesis testing to navigate data </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/PY"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/marketing-business-branding-advertising-word_53876-163235.jpg?w=996&t=st=1696570263~exp=1696570863~hmac=9038ed02b756eb7d41608651839e8873892ca936f40ec48bdedd12ab3b96a126"></img>
                          <h5 className='fw-bold text-center fs-6 py-2  Program_name_text mt-2'>Digital Marketing & Marketing</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>With the help of our extensive Digital Marketing course, take a fascinating voyage into the digital world. Examine the nuances of email and content marketing, from SEO and social media marketing to designing and creating advertisements. Explore strategies for Quora </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/DMM"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/medium-shot-man-working-laptop_23-2150323506.jpg?w=900&t=st=1696570322~exp=1696570922~hmac=a9760245a94018338e060424af238e36c4ca2f5c50c29538c790b1ddcaba4efc"></img>
                          <h5 className='fw-bold text-center fs-6 py-2 Program_name_text mt-2'>Full Stack Web Development</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Learn HTML, CSS, Bootstrap, SASS, JavaScript, DOM manipulation, jQuery, Node.js, SQL, React, WordPress, and Django as you embark on an extensive journey into Full Stack Web Development. This course covers the whole range, from basic concepts to sophisticated </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/FSW"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>

      <div className='container my-5'>
            <div className='row'>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/technology-coffee-internet-beverage-cafe-data-concept_53876-23193.jpg?w=996&t=st=1696570412~exp=1696571012~hmac=ff1ab40b141c279c2fd5455b186284db5483cfee1012329e9758277737f131e0"></img>
                          <h5 className='fw-bold  text-center py-2 Program_name_text'>Mern Stack</h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                             <p className='text-center'>Take a look at the exciting field of web development with our in-depth MERN stack course. Beginning with laying a solid foundation in HTML, CSS, and JavaScript, you can go on to learn React for effective front-end development, explore Node.js and Express.js for reliable </p>
                          </ul>
                          <div className='text-center'>
                          <Link to='/MS'><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                </div>
                </div>
                <div className='col-md-3'>
                <div>
                  <div className="Program_card">
                      <div className="card">
                      <div className="image">
                          <img href = "#" src ="https://img.freepik.com/free-photo/turned-gray-laptop-computer_400718-47.jpg?w=996&t=st=1696570575~exp=1696571175~hmac=eabaaef31c141132c9949923562b941c76965b85b24926ffa92daf109d4fd9ed  "></img>
                          <h5 className='fw-bold text-center py-2 Program_name_text'>C, C++ with DSA </h5>
                      </div>
                      <div className='content'>
                          <ul className='our_program_card_text pt-5 px-2'>
                              <p className='text-center'>Take a thorough look at Data Structures & Algorithms and C/C++ programming. This course gives you the tools to take on challenges in the real world. You will learn about advanced topics like OOPs, Trees, and Dynamic Programming, as well as fundamental concepts like </p>
                          </ul>
                          <div className='text-center'>
                          <Link to="/CCD"><button className='text-white bg-dark px-4 py-2 text-center border rounded-pill'>Learn More</button></Link>
                          </div>
                      </div>
                      </div>    
                  </div>
                  </div>
                </div>
            </div>
      </div>
    </div>
    </>
  )
}

export default Advance_program_card
